// STALLY redesign photo rotator (sections/stally-rd-story-page.liquid): a scroll-snap strip that swipes on its own; the
// arrows step it one photo, wrapping at the ends (so a focused arrow never turns disabled and drops focus), and the
// count follows where the strip settles.
const started = new WeakSet();

function start(root) {
  if (started.has(root)) return;
  started.add(root);
  const track = root.querySelector('.kb-track');
  const index = root.querySelector('[data-kb-index]');
  const count = track.children.length;
  const at = () => Math.round(track.scrollLeft / track.clientWidth);
  // The photo the strip is on or heading to: read from scrollLeft only once a scroll settles, because a smooth scroll
  // still under way reports a position between photos and a second click would step from the wrong one.
  let current = at();

  const show = (i) => {
    const shown = String(i + 1);
    if (index.textContent !== shown) index.textContent = shown;
  };

  for (const button of root.querySelectorAll('[data-kb-step]')) {
    button.addEventListener('click', () => {
      current = (current + Number(button.dataset.kbStep) + count) % count;
      show(current);
      track.scrollTo({ left: current * track.clientWidth });
    });
  }

  // scrollsnapchange would say when the strip settles, but Safari and Firefox lack it, so wait for scrolling to pause
  let timer;
  track.addEventListener('scroll', () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      current = at();
      show(current);
    }, 120);
  }, { passive: true });
}

const startAll = scope => scope.querySelectorAll('[data-kb-rotator]').forEach(start);
startAll(document);
// the theme editor re-renders a section without re-running scripts
document.addEventListener('shopify:section:load', event => startAll(event.target));
